import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-pencil.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const PencilIcon = createSvgIcon(<Icon />, 'PencilIcon');
